import { h, Fragment } from "preact";

import CardTemplate from "../Common/CardTemplate";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {

    Box,
    Stack,
    Tooltip,
    Typography,

} from "@mui/material";

import palette from "../../theme/palette";
import PersonAddIcon from '@mui/icons-material/PersonAdd';

export default function NotariesCard({ actualDeal, mode }) {

    return (
        <CardTemplate
            title="Notaires"
            buttons={
                <Fragment>
                    {(mode == "VN" && actualDeal.idp && actualDeal.sellers) &&
                        <ButtonWithTooltipAndBadge
                            tooltip="Inviter mon notaire à la vente"
                            icon={<GroupAddIcon />}
                            onclick_cb={() => {
                                app.refPopUp.current.handleChangeState(
                                    {
                                        opened: true,
                                        type: "010",
                                        uid: id,
                                        side: "VN"
                                    }
                                )
                            }}
                            badge={actualDeal.not_s_inv == 0} />
                    }
                    {mode == "AC" && actualDeal.idp && (actualDeal.buyers) &&
                        <ButtonWithTooltipAndBadge
                            tooltip="Inviter mon notaire à la vente"
                            icon={<GroupAddIcon />}
                            onclick_cb={() => {
                                app.refPopUp.current.handleChangeState(
                                    {
                                        opened: true,
                                        type: "010",
                                        uid: id,
                                        side: "AC"
                                    }
                                )
                            }}
                            badge={actualDeal.not_b_inv == 0} />
                    }
                </Fragment>
            }

            content={
                <Fragment>
                    <Box display="flex" justifyContent={"space-between"} alignItems="center">
                        <Box>
                            <Typography variant="h5">Notaire vendeur</Typography>
                        </Box>
                        <Box>
                            {actualDeal.not_s_inv ? (
                                <Tooltip title="Invité">
                                    <PersonAddIcon
                                        style={{
                                            color: palette.success.main,
                                        }}
                                    />
                                </Tooltip>
                            ) : (
                                <Tooltip title="Pas encore invité">
                                    <PersonAddIcon style={{
                                        color: palette.warning.main,
                                    }} />
                                </Tooltip>
                            )}
                            {actualDeal.not_s && <span>
                                {actualDeal.not_s_ok ? (
                                    <Tooltip title="Le notaire a accepté la gestion du dossier">
                                        <CheckCircleOutlineIcon
                                            style={{
                                                color: palette.success.main,
                                            }}
                                        />
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Le notaire doit accepter la gestion du dossier">
                                        <CheckCircleOutlineIcon
                                            style={{
                                                color: palette.warning.main,
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            </span>}

                        </Box>
                    </Box>
                    {actualDeal.not_s && (
                        <Stack spacing={0.5}>
                            <Box style="width: 100%; ">
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    style="width: 100%"
                                >
                                    <Box>
                                        <Typography variant="body1">{actualDeal.not_s.rs} </Typography>
                                        <Typography variant="body1">{actualDeal.not_s.name}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Typography variant="caption">{actualDeal.not_s.adr1}</Typography>
                            <Typography variant="caption">{actualDeal.not_s.adr2}</Typography>
                        </Stack>
                    )}

                    <Box display="flex" justifyContent={"space-between"} alignItems="center">
                        <Box>
                            <Typography variant="h5">Notaire acquéreur</Typography>
                        </Box>
                        <Box>
                            {actualDeal.not_b_inv ? (
                                <Tooltip title="Invité">
                                    <PersonAddIcon
                                        style={{
                                            color: palette.success.main,
                                        }}
                                    />
                                </Tooltip>
                            ) : (
                                <Tooltip title="Pas encore invité">
                                    <PersonAddIcon style={{
                                        color: palette.warning.main,
                                    }} />
                                </Tooltip>
                            )}
                            {actualDeal.not_b && <span>
                                {actualDeal.not_b_ok ? (
                                    <Tooltip title="Le notaire a accepté la gestion du dossier">
                                        <CheckCircleOutlineIcon
                                            style={{
                                                color: palette.success.main,
                                            }}
                                        />
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Le notaire doit accepter la gestion du dossier">
                                        <CheckCircleOutlineIcon
                                            style={{
                                                color: palette.warning.main,
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            </span>}
                        </Box>
                    </Box>
                    {actualDeal.not_b && (
                        <Stack spacing={0.5}>
                            <Box style="width: 100%; ">
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    style="width: 100%"
                                >
                                    <Box>
                                        <Typography variant="body1">{actualDeal.not_b.rs} </Typography>
                                        <Typography variant="body1">{actualDeal.not_b.name}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Typography variant="caption">{actualDeal.not_b.adr1}</Typography>
                            <Typography variant="caption">{actualDeal.not_b.adr2}</Typography>
                        </Stack>
                    )}

                </Fragment>
            }
        />)

}

